import type { DevToolsSliceState } from 'app/modules/wallforming/components/state-management/placement/states/devToolsSliceState';
import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';
import type { StateCreator } from 'zustand';

export const createDevToolsSlice: StateCreator<PlacementState, [], [], DevToolsSliceState> = (set) => ({
    prefabLayerTreeOpen: false,
    setPrefabLayerTreeOpen: (open) => set({ prefabLayerTreeOpen: open }),

    glbVisible: true,
    setGlbVisible: (visible) => set({ glbVisible: visible }),

    meshVisibility: {},
    setMeshVisibility: (meshId, visible) =>
        set((state) => ({ meshVisibility: { ...state.meshVisibility, [meshId]: visible } })),
    toggleAllMeshVisibility: (visible, meshIds) => {
        const meshVisibility: DevToolsSliceState['meshVisibility'] = {};
        for (const meshId of meshIds) {
            meshVisibility[meshId] = visible;
        }
        set({ meshVisibility });
    },

    layerVisibility: {},
    setLayerVisibility: (layerType, visible) =>
        set((state) => ({ layerVisibility: { ...state.layerVisibility, [layerType]: visible } })),

    toggleAllLayerVisibility: (visible, layerTypes) => {
        const layerVisibility: DevToolsSliceState['layerVisibility'] = {};
        for (const lt of layerTypes) {
            layerVisibility[lt] = visible;
        }
        set({ layerVisibility });
    },

    partLayerVisibility: {},
    setPartLayerVisibility: (partPath, layerType, visible) =>
        set((state) => ({
            partLayerVisibility: {
                ...state.partLayerVisibility,
                [`${partPath}::${layerType}`]: visible,
            },
        })),

    showFrustumViewer: false,
    setShowFrustumViewer: (show) => set({ showFrustumViewer: show }),
});
